// The saved date of a plan row, for opening its meal detail (MealView /
// GroupedMealView) with ?planId=.
//
// MealView treats the URL `date` as the saved row's own date: a pending row is
// completed only in that context, and the CTA reads "Log on <that date>". The
// plan-context endpoint does not return the row's date, so every caller that
// passes planId MUST pass the row's real date — never the screen's selected
// day or "today" when the row itself carries a date.
//
// `fallback` is used only when the row has no date (legacy / partial rows).
// planRowDate.guard.test.js fails if a caller sets planId without this helper.
export function planRowDate(row, fallback) {
  var d = row && typeof row.date === 'string' ? row.date.trim() : '';
  return d || fallback || '';
}

export default planRowDate;
